import { personas } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

const dot: Record<string, string> = {
  ok: "bg-accent-500 text-background-50",
  warn: "bg-secondary-400 text-background-50",
  idle: "bg-background-300 text-background-50",
};

const chip: Record<string, string> = {
  ok: "bg-accent-100 text-accent-700",
  warn: "bg-secondary-100 text-secondary-700",
  idle: "bg-background-200 text-foreground-500",
};

export default function PersonIndex() {
  return (
    <section id="renwu" className="border-y border-background-200/70 bg-background-100">
      <div className="container-x py-10 md:py-14">
        <SectionHeading
          kicker="按人切瓜 · 人物目录"
          title="人物档案索引"
          desc="吃瓜网爆把黑料大全与爆料合集按当事人归档：点开某个人，就能顺着他的实锤时间轴与全部相关帖子往下翻，不必在别处东拼西凑。"
        />

        {/* directory index */}
        <div className="rounded-2xl border border-background-200 bg-background-50 p-4 md:p-5">
          <div className="mb-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
            <span className="font-semibold text-foreground-700">快速索引</span>
            {["A-E", "F-J", "K-O", "P-T", "U-Z", "#"].map((g) => (
              <a
                key={g}
                href="#renwu"
                className="rounded-md bg-secondary-100 px-2.5 py-1 font-semibold text-secondary-700 transition-colors hover:bg-primary-500 hover:text-background-50 whitespace-nowrap"
              >
                {g}
              </a>
            ))}
            <span className="ml-auto hidden text-foreground-400 sm:inline">共 214 位当事人已建档</span>
          </div>

          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
            {personas.map((p) => (
              <a
                key={p.name}
                href="#shilu"
                className="group flex flex-col gap-3 rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300"
              >
                <div className="flex items-center gap-3">
                  <span
                    className={`grid h-10 w-10 shrink-0 place-items-center rounded-full text-sm font-bold ${dot[p.statusType]}`}
                  >
                    {p.name.slice(0, 1)}
                  </span>
                  <span className="min-w-0">
                    <span className="block truncate font-heading text-[15px] font-bold text-foreground-950">
                      {p.name}
                    </span>
                    <span className="text-xs text-foreground-500">{p.role}</span>
                  </span>
                </div>
                <span
                  className={`inline-flex w-fit items-center gap-1 rounded-md px-2 py-0.5 text-[11px] font-semibold whitespace-nowrap ${chip[p.statusType]}`}
                >
                  {p.status}
                </span>
                <span className="flex items-center justify-between border-t border-background-200/70 pt-2.5 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-file-list-3-line text-sm"></i>
                    {p.topics} 篇帖子
                  </span>
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5 group-hover:text-primary-600"></i>
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}